import { colors } from '../../Colors/colors'
export const tasksAndActivitiesTheme = {
   light: {
      cardBackGround: 'bg-base-white',
      taskDateTextColor: 'text-gray-700',
      taskTitle: 'text-gray-700',
      pageBackground: 'bg-gray-100',
      iconStroke: colors['gray-600'],
      activityIconsStroke: colors['gray-500'],
      activityDateTextColor: 'text-gray-500',
      activityTitle: 'text-gray-800'
   },
   dark: {}
}
